import GoogleAdUnit from "../../components/GoogleAdUnit";
import { ADSENSE_IN_FEED_LAYOUT_KEY } from "../../utility/googleAds";

const PeopleFeedAds = () => {
    return (
        <div className="row adsRow">
            <div className="col-md-6 ps-0">
                <div className="advertisementview mb-3" style={{ height: '200px' }}>
                    <div
                        className="advertisementContainer"
                        style={{
                            width: "97%",
                            height: "200px",
                            maxHeight: '200px',
                            overflow: "hidden",
                            margin: "20px auto",
                        }}
                    >
                        <GoogleAdUnit
                            adSlot="7349331462"
                            layoutKey={ADSENSE_IN_FEED_LAYOUT_KEY}
                            style={{
                                display: "block",
                                width: "97%",
                                height: "200px",
                                maxHeight: '200px',
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="col-md-6 pe-0">
                <div className="advertisementview mb-3" style={{ height: '200px' }}>
                    <div
                        className="advertisementContainer"
                        style={{
                            width: "100%",
                            height: "200px",
                            maxHeight: '200px',
                            overflow: "hidden",
                            margin: "20px auto",
                        }}
                    >
                        <GoogleAdUnit
                            adSlot="5695666532"
                            layoutKey={ADSENSE_IN_FEED_LAYOUT_KEY}
                            style={{
                                display: "block",
                                width: "100%",
                                height: "200px",
                                maxHeight: '200px',
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>

    );
};

export default PeopleFeedAds;
